var map = {
	"./de.json": [
		7830,
		258
	],
	"./en.json": [
		9842,
		842
	],
	"./fr.json": [
		2920,
		920
	],
	"./it.json": [
		3997,
		997
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1135;
module.exports = webpackAsyncContext;